import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOrangeArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 31,
	viewBox: "0 0 36 31",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.8653 30.374C10.6587 30.8862 10.076 31.134 9.56381 30.9274L1.21706 27.5612C0.704861 27.3546 0.4571 26.7719 0.663673 26.2597C0.870243 25.7475 1.45292 25.4998 1.96512 25.7063L9.38445 28.6986L12.3767 21.2792C12.5833 20.767 13.1659 20.5193 13.6781 20.7258C14.1903 20.9324 14.4381 21.5151 14.2315 22.0273L10.8653 30.374ZM34.8987 2.21915C28.4846 1.56614 19.7224 2.23241 13.9793 6.12065C11.1481 8.0375 9.06077 10.7272 8.30748 14.464C7.54847 18.2292 8.12117 23.172 10.8581 29.6087L9.01758 30.3913C6.18515 23.7301 5.48153 18.3616 6.34692 14.0688C7.21803 9.74752 9.65586 6.6325 12.8581 4.46452C19.1819 0.183106 28.5202 -0.440568 35.1013 0.229439L34.8987 2.21915Z",
		fill: "#FF8300"
	})
});
export default SvgOrangeArrowDown;
